// import axios from "axios";
import secure_axios from "../../services/secure_axios";
const initialState = () =>({
  allapprquestions: [],
  myAppraisees: [],
});


const state = initialState();

const getters = {
  allapprquestions: (state) => state.allapprquestions,
  myAppraisees: (state) => state.myAppraisees,
};

const mutations = {
  setAllApprQuestions(state, payload) {
    state.allapprquestions = payload;
  },
  setMyAppraisees(state, payload) {
    state.myAppraisees = payload;
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getAllApprQuestions({ commit, getters }) {
    commit("setLoading", true);
    commit("clearError");

    commit("setAllApprQuestions", []);

    secure_axios
      .get(`${getters.sessionAPI}apprques`)
      .then((response) => {
        commit("setAllApprQuestions", response.data.appr_questions);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },

  async getAllApprUsers({ commit, getters }) {
    const appr_code = getters.userProfile.EMPMST_DOCNO;
    if (!appr_code) {
      // console.error("appr_code is empty", appr_code);
      commit("setMyAppraisees",[])
      return Promise.reject("appr_code is empty"); // Reject the promise when appr_code is empty
    }
    commit("setLoading", true);
    try {
      const appraiseeRes = await secure_axios.get(`${getters.perferedAPI}appraisal/appraisee?appr_code=${appr_code}`);
      commit("setMyAppraisees", appraiseeRes.data);
      return Promise.resolve("Data fetched successfully");
    } catch (err) {
      // console.error(err);
      commit("setError", err);
      return Promise.reject("Failed to fetch data");
    } finally {
      commit("setLoading", false);
    }
  },
  // async getAllApprUsers({ commit, getters }) {
  //   // const company = getters.fbuserdata.company;
  //   // console.log("company",company)
  //   const appr_code = getters.userProfile.EMPMST_DOCNO;
  //   //  console.log("appr_code",appr_code)
  //   // check userProfile is loaded
  //   if (appr_code) {
  //     commit("setLoading", true);
  //     try {
  //     const appraiseeRes =  await secure_axios.get(`${getters.perferedAPI}appraisal/appraisee?appr_code=${appr_code}`)
  //       // console.log("appraiseeRes:",appraiseeRes.data)
  //       commit("setMyAppraisees", appraiseeRes.data)
  //       // console.log(appraiseeRes.data)
  //       commit("setLoading", false);
  //       return true
  //     } catch (err) {
  //       // Handle Error Here
  //       commit("setLoading", false);
  //       console.error(err);        
  //       commit("setError", err);
  //       return err
  //     }
  //   }
  //   else{      
  //     console.log("appr_code is empty",appr_code)//await  dispatch('')
  //     return error
  //   }
  // },

  async saveAppraisal({ commit, getters }, payload) {
    commit("setLoading", true);
    commit("clearError");

    const company = getters.fbuserdata.company;
    const uid = getters.factsuser.USER_DOCNO;
    const of_user = payload.of_user;
    const scores = payload.scores;

    try {
      const resp = await secure_axios.post(getters.sessionAPI + "appraisal", {
        by_user: {
          company: company,
          uid: uid,
        },
        of_user: of_user,
        scores: scores,
      });
      const apprmessage = await resp.data.new_appr;
      console.log(resp.data);

      if (apprmessage != null) {

        const company = getters.fbuserdata.company;
        const uid = getters.factsuser.USER_DOCNO;
        secure_axios
          .get(`${getters.sessionAPI}apprusrs?uid=${uid}&cpy=${company}`)
          .then((response) =>
            commit("setMyAppraisees", response.data.appr_users)
          );

        this.msgdialog = true;
        const displaymsg = `Appraisal saved for ${of_user} on ${apprmessage}. Have a nice day!`;
        commit("setMsgColor", "limegreen");
        commit("setMsgHeading", "Success!");
        commit("setMsgText", displaymsg);
        commit("setShowPop", true);
      }
    } catch (err) {
      // Handle Error Here
      console.error(err);
      commit("setError", err);
    }
    commit("setLoading", false);
  },
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
